// removed by extract-text-webpack-plugin
module.exports = {"title":"qempo_Referral_title-2RJgzYR","share":"qempo_Referral_share-Z4B03xA","referralWrap":"qempo_Referral_referralWrap-3KWIxDc","subtitleWrap":"qempo_Referral_subtitleWrap-11ob1jT","imageWrap":"qempo_Referral_imageWrap-ctnuPnA","textWrap":"qempo_Referral_textWrap-22TXp0p","codeWrap":"qempo_Referral_codeWrap-19MxNbW","couponCode":"qempo_Referral_couponCode-3AwAeJF","socialWrap":"qempo_Referral_socialWrap-3PPEDtT","terms":"qempo_Referral_terms-3WG8vak"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/preferences/referral/components/Referral.scss
// module id = 1411
// module chunks = 0